import type { FrontendOnlyPieces } from '../../../hooks/useSettings/WebsiteSettings';
import { WalnutPartnersFooter } from '../Footer';

// Walnut Commercial — frontend-only pieces; all data fields live on the backend
export const walnutCommercialFrontend: FrontendOnlyPieces = {
  slug: 'walnutcommercial',
  Footer: WalnutPartnersFooter,
};
